import { isBefore } from 'date-fns/isBefore';
import { startOfDay } from 'date-fns/startOfDay';

/**
 * 日付が過去日付でないか判定する
 *
 * - null / undefined は許容する（必須チェックは呼び出し側の責務）
 * - 判定基準はブラウザのローカル時間（`new Date()`）
 * - 時刻部分の差異を無視するため、両者を startOfDay で揃えてから比較する（今日は過去日扱いしない）
 */
export const isNotPastDate = (value: Date | null | undefined): boolean =>
  value === null || value === undefined || !isBefore(startOfDay(value), startOfDay(new Date()));
